import React from 'react';

const Error = () => {
    return (
        <div className='container'>
            <h1>404 Error</h1>
            <p>Go back to previous page</p>
            <h4>"You know what keeps going through my head? Where's my sandwich?"</h4>
        </div>
    );
};

export default Error;